import type { SVGProps } from "react";
// generated from Save.svg — do not edit manually
// prettier-ignore
export default function Save(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M6.5 22.5H2.5V2.5H15.5L20.5 7.5V22.5H16.5M6.5 22.5V14.5H16.5V22.5M6.5 22.5H16.5M6.5 7.5H11.5" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
